enum PageEnum {
    Introduction = "Introduction",
    Framework = "Framework",
    VisualFramework = "VisualFramework",
    FrameworkIntroduction = "FrameworkIntroduction",
    PromptTechniques = "PromptTechniques",
    AdversarialPrompting = "AdversarialPrompting",
    PromptInjections = "PromptInjections",
    PromptLeaking = "PromptLeaking",
    PromptJailbreak = "PromptJailbreak",
    PromptArchitecture = "PromptArchitecture",
    PromptEngineering = "PromptEngineering",
    LargeLanguageModels = "LargeLanguageModels",
    Applications = "Applications",
    Tools = "Tools"
}

export default PageEnum;